import React from 'react';
import { ParallaxSection } from '../components/ParallaxSection';
import { SectionHeading } from '../components/SectionHeading';
import { Award, Shield, CheckCircle, FileCheck, HardHat, Building } from 'lucide-react';
const certs = [{
  icon: Shield,
  title: 'OSHA Certified',
  description: 'Compliant with all Occupational Safety and Health Administration standards for construction safety.'
}, {
  icon: HardHat,
  title: 'Licensed General Contractor',
  license: 'CGC1541661',
  description: 'Certified General Contractor licensed by the State of Florida to build and manage commercial projects of any size.'
}, {
  icon: FileCheck,
  title: 'Bonded & Insured',
  description: 'Complete financial protection and liability coverage for all project stakeholders.'
}, {
  icon: Award,
  title: 'State Licensed Engineers',
  description: 'Our team includes licensed Professional Engineers (PE) across multiple disciplines.'
}];
export function CertificationsPage() {
  return <div className="bg-white min-h-screen" data-id="element-204" data-mp="1myjflpht7lod">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80" height="h-[50vh]" data-id="element-205" data-mp="1ryoyoha0jzuu">
        <h1 className="text-5xl md:text-7xl font-bold font-serif text-white text-center" data-id="element-206" data-mp="1wsjfncy8i0q8">
          Certifications
        </h1>
      </ParallaxSection>

      <section className="py-20 px-4 md:px-8" data-id="element-207" data-mp="142kwtzamuzu0">
        <div className="max-w-7xl mx-auto" data-id="element-208" data-mp="143w0lz42w7l4">
          <SectionHeading title="Standards & Compliance" subtitle="We adhere to the strictest industry standards to ensure safety, quality, and reliability." data-id="element-209" data-mp="18zt9jkd0ibnv" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-210" data-mp="1iz27spewucg1">
            {certs.map((cert, index) => <div key={index} className="bg-white p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-shadow flex flex-col items-center text-center group" data-id="element-211" data-mp="2pecljvettvh8" data-mpi={index}>
                <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#C5A55A] transition-colors duration-300" data-id="element-212" data-mp="udsoxu2l6ipj">
                  <cert.icon className="w-10 h-10 text-[#C5A55A] group-hover:text-white transition-colors duration-300" data-id="element-213" data-mp="13bctbbvqwv4d" />
                </div>
                <h3 className="text-xl font-bold font-serif text-black mb-3" data-id="element-214" data-mp="z8okh4717o7e">
                  {cert.title}
                </h3>
                {cert.license && <span className="inline-block mb-3 px-3 py-1 border border-[#C5A55A] text-[#C5A55A] text-xs font-semibold tracking-[0.15em] uppercase" data-id="element-215" data-mp="6nertp559to3">
                    License #{cert.license}
                  </span>}
                <p className="text-gray-600" data-id="element-216" data-mp="fkyvt5ue642e">{cert.description}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}